import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

// Photo "door" card: image starts muted, blooms to full color + slight scale
// on hover; paper info panel overlaps the bottom-left; subtle scroll parallax.
export default function DoorCard({ img, imgPosition, alt, title, body, href, cta = "Detaylar" }) {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const parallaxY = useTransform(scrollYProgress, [0, 1], [16, -16]);

  return (
    <motion.div ref={ref} style={{ y: reduced ? 0 : parallaxY }}>
      <Link to={href} className="group relative block overflow-hidden rounded-sm">
        <div className="relative h-[420px] overflow-hidden">
          <img
            src={img}
            alt={alt}
            loading="lazy"
            style={imgPosition ? { objectPosition: imgPosition } : undefined}
            className="w-full h-full object-cover saturate-[0.45] transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:saturate-100 group-hover:scale-[1.04]"
          />
          <div
            aria-hidden="true"
            className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent pointer-events-none"
          />
        </div>
        <div className="absolute left-0 bottom-0 right-16 bg-paper p-7 rounded-tr-sm">
          <h3 className="font-hanken font-bold text-xl text-ink tracking-[-0.015em]">{title}</h3>
          <p className="mt-2 text-[14.5px] leading-relaxed text-steel">{body}</p>
          <span className="inline-flex items-center gap-2 mt-4 text-sm font-bold text-royal">
            {cta}
            <span
              aria-hidden="true"
              className="inline-block transition-transform duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:translate-x-1"
            >
              →
            </span>
          </span>
        </div>
      </Link>
    </motion.div>
  );
}
